import * as React from "react"

export const ErrorPage = () => (
    <p>ErrorPage</p>
)
